import { v4 as uuidv4 } from 'uuid';

import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { IDecisionOrganizationForm } from 'DecisionPackage/MainModule/interfaces/IDecisionOrganizationForm';
import { IDecisionForm } from 'DecisionPackage/MainModule/interfaces/IDecisionForm';
import { IKnmErknmFormJudgment } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormJudgment';
import { IKnmErknmFormJudgmentCanceled } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormJudgmentCanceled';

import { createJudgmentKindSelectOption } from '../../../CorePackage/CatalogsModule/common/createJudgmentKindSelectOption';
import {
  getDistrictSelectOptions,
  getJudgmentCourtLevelSelectOptions,
} from '../../../CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { createJudgmentCourtSelectOption } from '../../../CorePackage/CatalogsModule/common/createJudgmentCourtSelectOption';
import { convertInitialKnmDateToFormDate } from '../../../KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { DATE_FORMAT_LONG_FNS } from '../../../CorePackage/MainModule/constants/dateFormats';
import { convertDecisionJudgmentSubjectsDataToFormValues } from './convertDecisionJudgmentSubjectsDataToFormValues';

// eslint-disable-next-line
const isEmpty = (value: any): boolean => {
  if (value === null || value === undefined) {
    return true;
  }

  if (typeof value === 'string' || Array.isArray(value)) {
    return value.length === 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
};

export const convertDecisionDataJudgmentsToFormValues = (
  state: IRootState,
  judgments: IKnm248['judgments'] | undefined,
  formOrganization: IDecisionOrganizationForm | undefined,
): IDecisionForm['judgments'] => {
  return judgments?.map(item => {
    const formJudgment: IKnmErknmFormJudgment = {
      ...item,
      guid: item.guid || undefined,
      dateJudgment: convertInitialKnmDateToFormDate(item.dateJudgment, DATE_FORMAT_LONG_FNS) || undefined,
      numberJudgment: item.numberJudgment || undefined,
      attachment: item.attachment || undefined,
      kindJudgment: item.kindJudgment ? createJudgmentKindSelectOption(item.kindJudgment) : undefined,
      rfRegionCode: item.court?.rfRegion
        ? getDistrictSelectOptions(state).find(x => x.code === `0${item.court?.rfRegion}`)
        : undefined,
      courtLevelCode: item.court?.courtType
        ? getJudgmentCourtLevelSelectOptions(state).find(x => x.code === item.court?.courtType)
        : undefined,
      court: item.court ? createJudgmentCourtSelectOption(item.court) : undefined,
      judgmentAction: item.judgmentAction || undefined,
      judgmentSubjectData: item.judgmentSubjectData
        ? convertDecisionJudgmentSubjectsDataToFormValues(item.judgmentSubjectData, formOrganization)
        : undefined,
      canceledJudgments:
        item.canceledJudgments?.map(canceledJudgment => {
          const formCanceledJudgment: IKnmErknmFormJudgmentCanceled = {
            ...canceledJudgment,
            guid: canceledJudgment.guid || undefined,
            numberJudgment: judgments?.find(x => x.guid === canceledJudgment.guid)?.numberJudgment || undefined,
            judgmentSubjectData: canceledJudgment.judgmentSubjectData
              ? convertDecisionJudgmentSubjectsDataToFormValues(canceledJudgment.judgmentSubjectData, formOrganization)
              : undefined,
            listId: uuidv4(),
          };

          return formCanceledJudgment;
        }) || undefined,
      createNewJudgment: !isEmpty(item.canceledJudgments) && !isEmpty(item.judgmentSubjectData) ? true : undefined,
      listId: item.guid || uuidv4(),
      isNew: !!item.isNew,
    };

    return formJudgment;
  });
};
